export default "__VITE_ASSET__yYMUSafi__"